"use strict";
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, closest, find, findAllIn} from "../libs/@elements/dom-utils";
import {activateScrollLock, deactivateScrollLock} from "../libs/@elements/scroll-lock";

export function init () {
    const isMobile = () => matchMedia('(max-width: 767px)').matches;

    let mainNav = find('.js-mega-nav');
    if(mainNav) {
        onFind('.js-mega-nav', function (item) {
            let $nav = item,
                $toggle = find('.js-mega-nav__toggle', $nav);

            on('click', function () {
                if (hasClass('is-open', $nav)) {
                    removeClass('is-open', $nav);
                    removeClass('is-open', $toggle);
                    deactivateScrollLock();
                } else {
                    addClass('is-open', $nav);
                    addClass('is-open', $toggle);
                    activateScrollLock();
                }
            }, $toggle);
        });

        onFind('.js-mega-nav__list-toggle', function (toggleButton) {
            let $list = closest('.js-mega-nav__list', toggleButton);
            let $listItems = findAllIn('.js-mega-nav__list-item', $list);

            on('click', function () {
                let $parentItem = closest('.js-mega-nav__list-item', this);
                if (hasClass('is-open', $parentItem)) {
                    removeClass('is-open', $parentItem);
                } else {
                    if (isMobile()) {
                        if (closest('.mega-nav ', $parentItem)) {
                            closest('.mega-nav ', $parentItem).scrollTop = 0;
                        }
                        addClass('is-open', $parentItem);
                    } else {
                        $listItems.forEach(function (item) {
                            removeClass('is-open', item)
                        });
                        addClass('is-open', $parentItem);
                    }

                    window.addEventListener("click", function _listener(evt) {
                        if (!$parentItem.contains(evt.target)) {
                            removeClass('is-open', $parentItem);

                            window.removeEventListener("click", _listener, true);
                        }
                    }, true);
                }
            }, toggleButton)
        });
    }
}
